export default __webpack_public_path__ + "static/media/mobile login2.ce10ecf2.gif";